// Custom icon: a Domino's-style storefront with a trending-up bar graph inside,
// flanked by £ and $ symbols. Matches lucide-react API (size, strokeWidth, className).
export default function StoreGraphIcon({ size = 24, strokeWidth = 1.6, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Storefront roof */}
      <path d="M3 9 L12 4 L21 9" />
      {/* Storefront body */}
      <path d="M5 9 V20 H19 V9" />
      {/* Door */}
      <path d="M10.5 20 V14 H13.5 V20" />
      {/* Rising bar graph inside (left of door) */}
      <line x1="6.5" y1="17" x2="6.5" y2="15.5" />
      <line x1="8" y1="17" x2="8" y2="13.5" />
      {/* Rising bar graph inside (right of door) */}
      <line x1="16" y1="17" x2="16" y2="14" />
      <line x1="17.5" y1="17" x2="17.5" y2="12" />
      {/* Trend arrow on the roof */}
      <path d="M14 7.5 L17 6 L20 7.5" />
      <polyline points="18.5 5.4 20 6 19.4 7.5" />
      {/* Currency symbols floating above */}
      <text x="2.5" y="6" fontSize="4.5" fontWeight="700" stroke="none" fill="currentColor">£</text>
      <text x="20" y="14.5" fontSize="4" fontWeight="700" stroke="none" fill="currentColor">$</text>
    </svg>
  );
}
